'use strict';

const getCookie = require('util/getCookie');

function controller($sce, $http, $window, appConfig) {
    const vm = this;

    vm.show_banner = false;

    function init() {
        try {
            const mos_data = getCookie(document.cookie, 'mos');

            if (mos_data) {
                vm.mos_data = JSON.parse(decodeURIComponent(decodeURIComponent(mos_data)));

                if (vm.mos_data.mos == 7) {
                    vm.message = $sce.trustAsHtml('You can\'t purchase single tickets while you have a subscription in your cart.');
                    vm.show_banner = true;
                }
            }

        } catch (e) {
            console.warn('error initialising subscription warning bar – this error is being caught so we don\'t show the bar in a bugged/broken state');
        }
    }

    init();

    return vm;
}

module.exports = [
    '$sce',
    '$http',
    '$window',
    'appConfig',
    controller,
]



// WEBPACK FOOTER //
// ./widgets/controllers/SubNotice.js